<template>

</template>

<script>

export default {
	data() {
		return {
			last_activity: null,
			token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
		}
	},

	created() {
		//set starting time
		this.last_activity = Math.floor(Date.now() / 1000);

		//watch all clicks
		window.addEventListener('mouseup', e => {
			this.last_activity = Math.floor(Date.now() / 1000);
		});

		//two-minute clock
		setInterval(() => { this.timeCheck() }, 120 * 1000);
	},

	methods: {
		logout(expired) {
			const redirectTo = expired ? '/login?expired=true' : '/login';

			//should throw a 401 by design -- send back to login no matter what.
			axios.post('/logout', { _token: this.token }).then(() => {
				location.replace(redirectTo);
			}).catch(() => {
				location.replace(redirectTo);
			});
		},

		timeCheck() {
			//two hours (maybe computer closed?, log out
			if ((Math.floor(Date.now() / 1000)) - this.last_activity > 119 * 60) {
				this.logout(true);
			}

			if ((Math.floor(Date.now() / 1000)) - this.last_activity > 60 * 60) {
				let timerInterval
				Swal.fire({
					icon: 'question',
					title: 'Are you still there?',
					html: 'You\'ve been inactive for a while. You will automatically be logged out in <b></b> seconds.',
					timer: 60 * 1000,
					timerProgressBar: true,
					confirmButtonText: 'Stay here',
					cancelButtonText: 'Log out',
					showCancelButton: true,
					showConfirmButton: true,
					onBeforeOpen: () => {
						//Swal.showLoading()
						timerInterval = setInterval(() => {
				  			const content = Swal.getContent()
				  			if (content) {
				    			const b = content.querySelector('b')
				    			if (b) {
				      				b.textContent = Math.floor(Swal.getTimerLeft() / 1000)
				    			}
				  			}
						}, 100)
					},
					onClose: (result) => {
						clearInterval(timerInterval)
					}
				}).then((result) => {
					//log out if the modal times out or user hits logout button
					if (result.dismiss === Swal.DismissReason.timer) {
						this.logout(true);
					}

					if (result.dismiss === 'cancel') {
						this.logout();
					}
				});
			}
		}
	},

}
</script>